'use strict';
import 'jquery.cookie';
var $ = require('jquery');
var Radio = require('backbone.radio');
var StepTitleView = require('../step-title').default;
var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;
var Tracker = require('../../../analytics/events').default;
var EmptyView = require('../appointments/no-appointments').default;
var AppointmentDetailsView = require('../appointments/details').default;

export default Marionette.View.extend({

  className: 'l-cancel',
  template: require('./templates/cancel.hbs'),
  regions: {
    title: '.l-cancel-title',
    body: '.l-cancel-body',
  },

  initialize: function () {
    Tracker.trackView('manage');
    if (!window.APPOINTMENTS.length) {
      this.cancelled = true;
    } else if (window.APPOINTMENTS[0].appointmentclient) {
      this.cancelled = window.APPOINTMENTS[0].appointmentclient[0].cancelled;
    } else {
      this.cancelled = window.APPOINTMENTS[0].attributes.appointmentclient[0].cancelled;
    }

    var message = $.cookie('waitlistRequestBooked');
    $.removeCookie('waitlistRequestBooked');
    if (!this.cancelled) {
      this.bodyView = new AppointmentDetailsView({
        showMessage: message ? polyglot.t('confirmation.request_booked') : false,
      });
    } else {
      this.bodyView = new EmptyView();
    }

    this.showCookieMessage();
  },

  onRender: function () {
    this.showChildView('title', new StepTitleView({
      title: polyglot.t('pages.cancel.long_title'),
    }));
    this.showChildView('body', this.bodyView);
  },

  showCookieMessage: function () {
    if (!$.cookie('cookiesAccepted')) {
      Radio.channel('long-toast').trigger('show', {
        message: polyglot.t('messages.cookies'),
        modalSize: 'large',
        buttonMessage: polyglot.t('messages.cookies_confirm'),
        buttonClass: 'cookie',
        showIcon: false,
      });
    }
  },

});
